import Creation from '../component/Creation'

const Service = () => {
  return (
    <div>
      <Creation/>
    </div>
  )
}

export default Service;